export interface Default {
    [key:string] : any
}

export interface LatestRoleNPermissions {
  status: Boolean,
  user: any,
  permissions: any
}

export const UTCFormatDate = (dateString: string, format="MM/DD/YY HH:mm A"): string => {
  if(!dateString) return "N/A";
  const date = new Date(dateString);

  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  const year = date.getUTCFullYear().toString().slice(-2);
  const fullYear = date.getUTCFullYear();

  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12;

  switch (format) {
    case 'MM/DD/YYYY':
      return `${month}/${day}/${fullYear}`  ;
  
    default:
      return `${month}/${day}/${year} ${formattedHours}:${String(minutes).padStart(2, '0')} ${ampm}`;
  }
}